// src/components/routes/PublicRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Spinner } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <Spinner animation="border" variant="primary" className="mb-3" />
          <p className="text-muted">Загрузка...</p>
        </div>
      </Container>
    );
  }
  
  return user ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;